import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LocalDataSource } from 'ng2-smart-table';
import { Logger } from '@app/core';
import { ReporteTramite, ConfirmComponent, TramiteBase } from '@app/shared';
import { ReportsDataSourceConfig } from './shared/reports-data-source.config.service';
import { ReportsDataSourceDataService } from './shared/reports-data-source.data.service';
import { ReportsDataService } from '../shared/reports.data.service';
import { Subject } from 'rxjs';

const log = new Logger('ReportsDataSourceComponent');

@Component({
  selector: 'iw-reports-data-source',
  templateUrl: './reports-data-source.component.html',
  styleUrls: ['./reports-data-source.component.scss'],
  providers: [ReportsDataSourceDataService, ReportsDataService]
})
export class ReportsDataSourceComponent implements OnInit, OnDestroy {

  // Contiene el id del reporte seleccionado
  @Input() idReport = -1;
  // Contiene la lista de tramites asociados a el reporte
  @Input() reportTramites: ReporteTramite[] = [];
  // Contiene la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal
  question = '';
  // Contiene el id del tramite seleccionado
  idReportTramite = -1;
  // Define cuando mostrar el formulario
  openForm = false;
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;

  constructor(
    private rdsds: ReportsDataSourceDataService,
    private rds: ReportsDataService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    // Se inicia la configuracion de la tabla
    const configTable = new ReportsDataSourceConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((data: any) => {
      log.debug(data);
      this.defineAction('delete', data.row);
    });
    if (this.reportTramites && this.reportTramites.length) {
      this.sourceData = new LocalDataSource(this.reportTramites);
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Controla las acciones a realizar
   *
   * @param {('add' | 'delete' | 'close')} [action='add']
   * @param {*} [data]
   * @memberof ReportsDataSourceComponent
   */
  defineAction(action: 'add' | 'delete' | 'close' = 'add', data?: any) {
    switch (action) {
      case 'close':
        this.actionForm = '';
        this.openForm = false;
        this.question = '';
        this.idReportTramite = -1;
        break;
        case 'delete':
        this.actionForm = '';
        this.openForm = false;
        this.question = '¿Realmente desea eliminar el reporte?';
        this.confirm.open();
        this.idReportTramite = data.id;
        break;
        default:
        this.actionForm = 'Agregar';
        this.openForm = true;
        this.idReportTramite = -1;
        break;
    }
  }

  /**
   * Guarda o asocia un tramite a el reporte seleccionado
   *
   * @param {TramiteBase} tramite
   * @memberof ReportsDataSourceComponent
   */
  sended(tramite: TramiteBase) {
    if (tramite && tramite.id) {
      this.rdsds.addAsociationReportTramite({tramite: tramite.id, reporte: this.idReport}).subscribe(resp => {
        if (resp) {
          this.loadingReportsTramite();
          this.defineAction('close');
        }
      });
    } else {
      this.toastr.error('Debe seleccionar un trámite.', 'Error de operación');
    }
  }

  /**
   * Controla las acciones realizadas en el modal de confirmaciones
   *
   * @param {boolean} resp
   * @memberof ReportsDataSourceComponent
   */
  actionComfirm(resp: boolean) {
    if (resp) {
      this.deleteAssociationReport();
    }
  }

  /**
   * Elimina el reporte seleccionado
   *
   * @private
   * @memberof ReportsDataSourceComponent
   */
  private deleteAssociationReport() {
    if (this.idReportTramite !== -1) {
      this.rdsds.deleteAsociationReportTramite(this.idReportTramite).subscribe(resp => {
        if (resp) {
          this.loadingReportsTramite();
          this.defineAction('close');
        }
      });
    }
  }

  /**
   * Consulta y carga los tramites asociados a el reporte
   *
   * @private
   * @memberof ReportsDataSourceComponent
   */
  private loadingReportsTramite() {
    this.rds.getReportsTramites(this.idReport).subscribe(reportTramites => {
        this.sourceData = new LocalDataSource(reportTramites);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-data-source/reports-data-source.component.ts